import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

// Import components
import Login from "./components/Login";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import StateView from "./components/StateView";
import DistrictView from "./components/DistrictView";
import SiteDirectory from "./components/SiteDirectory";
import SiteView from "./components/SiteView";
import Performance from "./components/Performance";
import Generation from "./components/Generation";
import RMSDevices from "./components/RMSDevices";
import RMSHealth from "./components/RMSHealth";
import Maintenance from "./components/Maintenance";
import Complaints from "./components/Complaints";
import Escalations from "./components/Escalations";
import Reports from "./components/Reports";
import SiteComparison from "./components/SiteComparison";
import Weather from "./components/Weather";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/state-view" element={<StateView />} />
            <Route path="/district/:districtId" element={<DistrictView />} />
            <Route path="/site-directory" element={<SiteDirectory />} />
            <Route path="/site/:siteId" element={<SiteView />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/generation" element={<Generation />} />
            <Route path="/rms-devices" element={<RMSDevices />} />
            <Route path="/rms-health" element={<RMSHealth />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/escalations" element={<Escalations />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/site-comparison" element={<SiteComparison />} />
            <Route path="/weather" element={<Weather />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
